module.exports = __webpack_public_path__ + "static/media/rabbitTrain.4f6a448a.png";